export class DistrictModel{
    DistrictId : any;
    IsActive : any;
    DistrictName : any;
    DistrictCode : any;
    DivisionId:any;
    ProvinceId: any;
}
export class edit{
    DistrictId : any;
    IsActive : any;
    DistrictName : any;
    DistrictCode : any;
    Code:any;
    DivisionId:any;
    ProvinceId: any;
}
export class filt{
    DistrictId : any;
    IsActive : any;
    DistrictName : any;
    DistrictCode : any;
    DivisionId:any;
    ProvinceId: any;
}